<div class="upsell-multi-selector desktop:px-4">
  <div class="upsell-multi-selector__container justify-center mx-auto w-full bg-white">

    @if (productBoxTitle) {
      <div class="upsell-multi-selector__title text-center p-4 font-bold text-4xl" [innerHTML]="productBoxTitle">
      </div>
    }
    @if (productBoxSubTitle) {
      <div class="upsell-multi-selector__subtitle text-center p-4 text-2xl max-w-2xl m-auto" [innerHTML]="productBoxSubTitle">
      </div>
    }
    <div class="upsell-multi-selector__wrapper">

      <div class="upsell-multi-selector__content p-4 flex flex-col items-center desktop:flex-row gap-6">

        <div
          class="upsell-multi-selector__image-wrapper basis-2/5 mx-auto flex flex-col justify-center desktop:flex-shrink-0">
          <img class="upsell-multi-selector__image self-center"
            src="{{ selectedProduct?.img || 'assets/img/No-Image-Available.jpg' }}" alt="{{ imageAlt }}">
          </div>

          <div class="upsell-multi-selector__description w-full basis-3/5">
            @if (productBoxOptionTitle) {
              <p class="upsell-multi-selector__subtitle mb-2 font-bold" [innerHTML]="productBoxOptionTitle">
              </p>
            }
            <!-- Product Selection Options -->
            <div class="border border-black">
              @if (productOptions && productOptions.length > 0) {
                @for (product of productOptions; track $index; let i = $index) {
                  <div class="border-b border-black cursor-pointer transition-colors duration-200"
                    [class.bg-badlands-active]="selectedProduct?.sfid === product.sfid" (click)="selectProduct(product)">
                    <div class="grid upsell-multi-selector__grid gap-2 desktop:gap-4 p-2.5 items-center">
                      <!-- 1. Selection Indicator -->
                      <div class="upsell-multi-selector__check flex items-center">
                        <div class="w-8 h-8 border-2 border-black rounded-full flex items-center justify-center"
                          [class.bg-lw-green]="selectedProduct?.sfid === product.sfid"
                          [class.border-badlands-green]="selectedProduct?.sfid === product.sfid">
                          <svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20"
                            [style.display]="selectedProduct?.sfid === product.sfid ? 'block' : 'none'"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path fill-rule="evenodd"
                              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clip-rule="evenodd"></path>
                          </svg>
                        </div>
                      </div>
                      <!-- 2. Flavor and Description -->
                      <div class="upsell-multi-selector__flavor">
                        <h3 class="text-xl font-bold">{{ product.displayName }}</h3>
                        <p class="text-xs desktop:text-sm">{{product.quantity}} {{ product.unit }}</p>
                      </div>
                      <!-- 3. Savings -->
                      <div class="upsell-multi-selector__savings flex items-center justify-center">
                        <div class="text-orange-500 text-xs desktop:text-sm">Save {{ (product.regularPrice -
                        product.offerPrice) | dynamicCurrency:currency }}</div>
                      </div>
                      <div class="upsell-multi-selector__savings flex items-center justify-center">
                        <div class="text-gray-400 text-xs desktop:text-sm line-through mb-1">{{ product.regularPrice |
                        dynamicCurrency:currency }}</div>
                      </div>
                      <!-- 4. Price Breakdown -->
                      <div class="upsell-multi-selector__price">
                        <div class="text-base desktop:text-lg font-bold">{{ product.offerPrice | dynamicCurrency:currency }}</div>
                      </div>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

